import React from 'react';
import { Modal } from '../../modal';
import { WelcomeScreenModal } from '../../modal/welcome-screen-modal';

const WelcomeScreenModalParent = props => {
    const { onClick } = props;

    return (
        <Modal ariaLabel="welcome letter" onClick={onClick}>
            <WelcomeScreenModal />
        </Modal>
    );
};

export { WelcomeScreenModalParent };
